import { useState } from 'react';
import useAuthContext from './useAuthContext';
import api from '../api';
import useLoaderContext from './useLoaderContext';
import { Link } from 'react-router-dom';

export default function useLogin() {
    const [error, setError] = useState(null);
    const { setToken } = useAuthContext();
    const { dispatch:loadingDispatch } = useLoaderContext();
   
    // API to resent the email
    const resendEmail = async (token) => {
        try {
            await api.post("/user/sendConfirmationEmail", 
                {}, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${token}`
                    }
                }
            );
            setError(null);
        } catch (error) {
            setError(error.response?.data?.detail || "An error occurred.");
        }
    };

    const login = async (formData) => {
        try {
            loadingDispatch({ type: 'LOAD' });
            setError(null);
            const { data } = await api.post('/login', formData);
            setToken(data.access);
            loadingDispatch({ type: 'NO_LOAD' });
        } catch (error) {
            const { data } = error.response;
            
            if (data.message && data.access && data.refresh) {
                // problem with email verification
                setError([
                    <span>Email Verification is needed. </span>,
                    <Link 
                        to="/mail-confirmation"
                        state={{ token: data.access, email: formData.email }}
                        className="resend-login" 
                        onClick={() => resendEmail(data.access)}
                    >Resend Email</Link>
                ])
            } else {
                setError(<span>{data?.message || "An error occurred. Please try again."}</span>);
            }
            loadingDispatch({ type: 'NO_LOAD' });
        }
    }

    return { login, error, setError };
}